import { httpsCallable } from "firebase/functions";
import { functions } from "../../../config/firebase-config";
import { notifyPermissionDenied } from "../handleCallableError";

export const getAdminStatsByDealership = async (dealershipId, groupId) => {
  if (!dealershipId) {
    console.error("ID de concesionario no proporcionado");
    throw new Error("ID de concesionario no proporcionado");
  }

  try {
    const getStatsFn = httpsCallable(functions, "getAdminStatsByDealershipV2");
    const result = await getStatsFn({
      dealershipId,
      groupId,
      requestedApp: "group_web",
    });
    if (Array.isArray(result.data)) {
      return result.data;
    }
    if (result.data && result.data.success === "yes") {
      return result.data.data;
    }
    if (result.data && result.data.success === undefined) {
      return result.data;
    }
    throw new Error(
      result.data?.message || "Error al obtener estadísticas de admin",
    );
  } catch (error) {
    console.error("Error obteniendo estadísticas de admin:", error);
    notifyPermissionDenied(error);
    throw error;
  }
};
